import { FEATURE_PAGES } from '../../data/featurePages';
import Layout from '../../components/feature/Layout';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function FeaturesPage() {
  // SEO設定
  useSEO({
    title: '教科別まとめページ｜キョウコレ',
    description: '中学生向けの教科別学習ガイド。数学、英語、国語、理科、社会の各教科について、学年別・単元別に整理した学習情報を提供しています。',
    keywords: '教科別まとめ,数学,英語,国語,理科,社会,中学生,学習ガイド,単元別',
    canonical: (import.meta.env.VITE_SITE_URL || 'https://example.com') + '/features',
    jsonLd: generateWebPageSchema(
      '教科別まとめページ｜キョウコレ',
      '中学生向けの教科別学習ガイド。数学、英語、国語、理科、社会の各教科について、学年別・単元別に整理した学習情報を提供しています。',
      '/features'
    ),
  });

  const publishedFeatures = FEATURE_PAGES.filter((f) => f.isPublished);
  
  // 教科別まとめページ
  const subjectSummaries = publishedFeatures.filter((f) => f.slug.endsWith('-summary'));
  
  // その他の特集
  const otherFeatures = publishedFeatures.filter((f) => !f.slug.endsWith('-summary'));

  return (
    <Layout>
      <div className="max-w-4xl mx-auto py-10 px-4">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
          特集ページ
        </h1>
        <p className="text-gray-600 mb-8">
          高校受験や定期テストの対策に役立つ特集を集めました。教科別に整理された学習ガイドや、無料教材サイトの一覧をご覧いただけます。
        </p>

        {/* 教科別まとめセクション */}
        {subjectSummaries.length > 0 && (
          <section className="mb-12">
            <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900 border-b-2 border-teal-500 pb-2">
              教科別まとめ
            </h2>
            <p className="text-gray-600 mb-6">
              各教科の学習内容を学年別・単元別に整理しました。つまずきやすいポイントや、おすすめの無料教材サイトを一覧で確認できます。
            </p>
            <div className="space-y-4">
              {subjectSummaries.map((feature) => (
                <a
                  key={feature.slug}
                  href={feature.path}
                  className="block bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md hover:border-teal-400 transition-all duration-200 cursor-pointer"
                >
                  <h3 className="text-lg md:text-xl font-semibold mb-2 text-gray-900">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-600">{feature.description}</p>
                </a>
              ))}
            </div>
          </section>
        )}

        {/* その他の特集セクション */}
        {otherFeatures.length > 0 && (
          <section>
            <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-900 border-b-2 border-teal-500 pb-2">
              その他の特集
            </h2>
            <div className="space-y-4">
              {otherFeatures.map((feature) => (
                <a
                  key={feature.slug}
                  href={feature.path}
                  className="block bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md hover:border-teal-400 transition-all duration-200 cursor-pointer"
                >
                  <h3 className="text-lg md:text-xl font-semibold mb-2 text-gray-900">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-600">{feature.description}</p>
                </a>
              ))}
            </div>
          </section>
        )}

        {publishedFeatures.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            現在公開中の特集はありません
          </div>
        )}
      </div>
    </Layout>
  );
}